import React from "react";
import { DiWindows, DiLinux } from "react-icons/di";
import {
	SiVisualstudiocode,
	SiMacos,
	SiPostman,
	SiVercel,
	SiSlack,
	SiAzuredevops,
	SiSublimetext,
} from "react-icons/si";

// components
import Card from "../Card";

const toolStacks = [
	{
		id: 2,
		title: "Postman",
		icon: <SiPostman />,
		color: "",
		level: 5,
	},
	{
		id: 3,
		title: "VSCode",
		icon: <SiVisualstudiocode />,
		color: "",
		level: 5,
	},
	{
		id: 4,
		title: "Linux",
		icon: <DiLinux />,
		color: "",
		level: 5,
	},
	{
		id: 5,
		title: "macOS",
		icon: <SiMacos />,
		color: "",
		level: 5,
	},
	{
		id: 6,
		title: "Windows",
		icon: <DiWindows />,
		color: "",
		level: 5,
	},
	{
		id: 7,
		title: "Azure DevOps",
		icon: <SiAzuredevops />,
		color: "",
		level: 5,
	},
	{
		id: 8,
		title: "Vercel",
		icon: <SiVercel />,
		color: "",
		level: 5,
	},
	{
		id: 9,
		title: "Slack",
		icon: <SiSlack />,
		color: "",
		level: 5,
	},
	{
		id: 10,
		title: "Sublimetext",
		icon: <SiSublimetext />,
		color: "",
		level: 5,
	},
];

const toolStackCards = toolStacks.map((toolStack) => (
	<Card
		key={toolStack.id}
		title={toolStack.title}
		icon={toolStack.icon}
		color={toolStack.color}
		level={toolStack.level}
	/>
));

const ToolStack = () => {
	return (
		<div>
			<h1 className="text-center text-5xl font-bold mb-2 py-2">
				<span className="text-green-800">Tools</span> I use:
			</h1>
			<div className="p-5 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5">
				{toolStackCards}
			</div>
		</div>
	);
};

export default ToolStack;
